

import React, { memo } from 'react';
import memoize from 'lodash.memoize';
import _sortBy from 'lodash.sortby';
import cx from 'classnames';
import {
  WRAPPER,
  CREATE_WRAPPER,
  CREATE_BOX,
  CREATE_TEXT,
  LOADING_WRAPPER,
  LOADING_H1,
  LOADING_P } from
'../styles/recentList';
import Icon from '../../Icon';
import onEnterPressed from '../../../common/utils/onEnterPressed';











const ICON_SIZES = {
  square: 65,
  small: 25
};

const loadingElement = (item) =>
<div key={item.id} className={cx('loading-wrapper', LOADING_WRAPPER)}>
    <div className={cx('loading-h1', LOADING_H1)} />
    <div className={cx('loading-p', LOADING_P(135))} />
    <div className={cx('loading-p', LOADING_P(145))} />
    <div className={cx('loading-p', LOADING_P(140))} />
    <div className={cx('loading-p', LOADING_P(150))} />
  </div>;


const getMostRecentItems = memoize(({ data, limit = 5 }) => {
  const sortedData = _sortBy(data, 'updatedAt').reverse();

  return sortedData.slice(0, limit);
});







const createBox = ({ onCreate, createText, size }) =>
<div className={cx('create-wrapper', CREATE_WRAPPER)} onClick={onCreate} onKeyPress={onEnterPressed({ onClick: onCreate })} role="button" tabIndex={0}>
    <div className={cx('create-box', CREATE_BOX(size))}>
      <Icon name="addthin" size={ICON_SIZES[size]} color="regent" />
      {size !== 'square' && <p className={cx('create-text', CREATE_TEXT)}>{createText || 'Create New'}</p>}
    </div>
    {size === 'square' && <p className={cx('create-text', CREATE_TEXT)}>{createText || 'Create New'}</p>}
  </div>;


function RecentList(
{
  data,
  renderElement,
  loading,
  onCreate,
  createText,
  size = 'square',
  limit
})
{
  const recentItems = getMostRecentItems({ data, limit });

  return (
    <div className={cx('recent-list', WRAPPER(size))}>
      {onCreate && createBox({ onCreate, createText, size })}
      {recentItems.map(loading ? loadingElement : renderElement)}
    </div>);

}

RecentList.defaultProps = {
  loading: false
};

export default memo(RecentList);